<template>
  <div>
    <footer class="footer">
      <div class="container">
        <div class="row">
<!--          <div class="col-md-3">-->
<!--            <a class="navbar-brand" href="https://www.offthecouch.io">-->
<!--              <img style="width: 70px; height: 70px; padding: 0" class="card-img" src="img/otcteal_logowhite.png" alt="Image" />-->
<!--            </a>-->
<!--          </div>-->
          <div class="col-md-3 nav">
            <h3 class="title">Off The Couch</h3>
          </div>
          <div class="col-lg-3 col-4 text-center">
            <ul class="nav">
              <li class="nav-item">
                <a href="/" class="nav-link">
                  Home
                </a>
              </li>
              <li class="nav-item">
                <a href="/about" class="nav-link">
                  About
                </a>
              </li>
              <li class="nav-item">
                <a href="/contact" class="nav-link">
                  Contact us
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-4 text-center">
            <ul class="nav">
              <li class="nav-item">
                <a href="/pricing" class="nav-link">
                  Pricing
                </a>
              </li>
              <li class="nav-item">
                <a href="/demo" class="nav-link">
                  Get demo
                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-3 col-4 text-center">
            <ul class="nav">
              <li class="nav-item">
                <a
                  href="https://www.iubenda.com/privacy-policy/85460032"
                  class="nav-link iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe"
                  title="Privacy Policy"
                >
                  Privacy Policy
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="https://www.iubenda.com/privacy-policy/85460032/cookie-policy"
                  class="nav-link iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe"
                  title="Cookie Policy"
                >
                  Cookie Policy
                </a>

              </li>
              <li class="nav-item">
                <a href="https://www.iubenda.com/terms-and-conditions/85460032"
                   class="nav-link iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe "
                   title="Terms and Conditions ">Terms and Conditions</a>

              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>

</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  mounted(){
    const loader = () => {
      const script = document.createElement("script");
      script.src = "https://cdn.iubenda.com/iubenda.js";
      const tag = document.getElementsByTagName("script")[0];
      tag.parentNode.insertBefore(script, tag);
    };

    if (window.addEventListener) {
      window.addEventListener("load", loader, false);
    } else if (window.attachEvent) {
      window.attachEvent("onload", loader);
    } else {
      window.onload = loader;
    }
  }
};
</script>
<style></style>
